import { marshal, Nullable } from "@gsx/common";
import { injectable } from "inversify";
import { EditStore } from "../../general/EditStore";
import { Api } from "../../../../../common/src/api/Api";
import { MergerAcquisitionBody } from "@gsx/common/src/types/http/admin/mergerAcquisition";
import { createMergerAcquisitionEmptyBody } from "../../..//utility/entity/mergerAcquisition";

// EditStoreVuex is not used here, because components are modifying
// data properties directly. That behaviour is not supported by vuex.
// The whole data would have to be replaced instead.

@injectable()
export class MergerAcquisitionsEditStore extends EditStore<MergerAcquisitionBody> {
    private id: string = "";
    readonly data: Nullable<MergerAcquisitionBody> = createMergerAcquisitionEmptyBody();

    constructor(private readonly api: Api) {
        super();
    }

    public setId(value: string): void {
        this.id = value;
    }

    protected async loadRequest(): Promise<MergerAcquisitionBody> {
        return this.api.admin.mergerAcquisition.get(this.id);
    }

    protected async updateRequest(): Promise<void> {
        const body = marshal(this.data);
        await this.api.admin.mergerAcquisition.update(this.id, body);
    }
}
